document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-featured-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-featured-carousel-viewport]');
    const track = carousel.querySelector('[data-featured-carousel-track]');
    const slider = carousel.querySelector('[data-featured-carousel-slider]');
    const sliderWrap = carousel.querySelector('[data-featured-carousel-slider-wrap]');
    const originalSlides = Array.from(track?.querySelectorAll('.featured-carousel-slide') || []);
    let translate = 0;
    let frame = null;
    let lastTimestamp = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchStartTranslate = 0;
    let isTouchDragging = false;
    let mobileInterval = null;

    if (!viewport || !track || !originalSlides.length) return;

    originalSlides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
      track.appendChild(clone);
    });

    const slides = Array.from(track.querySelectorAll('.featured-carousel-slide'));
    const visibleCount = () => (window.innerWidth >= 990 ? 4 : 1);
    const maxIndex = () => Math.max(0, originalSlides.length - 1);
    const cycleWidth = () => {
      const firstClone = slides[originalSlides.length];
      return firstClone ? firstClone.offsetLeft : track.scrollWidth;
    };
    const canAutoplay = () => originalSlides.length > visibleCount() && cycleWidth() > viewport.clientWidth;
    const baseSpeed = () => (window.innerWidth >= 990 ? 24 : 18);
    const normalizedTranslate = (value) => {
      const width = cycleWidth();

      if (width <= 0) return 0;

      let nextValue = value;
      while (nextValue < 0) nextValue += width;
      while (nextValue >= width) nextValue -= width;
      return nextValue;
    };

    const nearestIndex = () => {
      let bestIndex = 0;
      let bestDistance = Infinity;

      originalSlides.forEach((slide, slideIndex) => {
        const distance = Math.abs(slide.offsetLeft - translate);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = slideIndex;
        }
      });

      return bestIndex;
    };

    const setTranslate = (value) => {
      translate = normalizedTranslate(value);
      track.style.transform = `translateX(${-translate}px)`;
      if (slider) {
        slider.value = String(Math.min(maxIndex(), nearestIndex()));
      }
    };

    const offsetForIndex = (nextIndex) => {
      const slide = slides[Math.max(0, Math.min(originalSlides.length - 1, nextIndex))];
      return slide ? slide.offsetLeft : 0;
    };

    const syncControls = () => {
      const isScrollable = canAutoplay();

      if (sliderWrap) {
        sliderWrap.hidden = !isScrollable;
      }
      if (slider) {
        slider.max = String(maxIndex());
      }
    };

    const stopAutoplay = () => {
      lastTimestamp = 0;
      if (frame) {
        window.cancelAnimationFrame(frame);
        frame = null;
      }
      if (mobileInterval) {
        window.clearInterval(mobileInterval);
        mobileInterval = null;
      }
    };

    const autoplayStep = (timestamp) => {
      if (!canAutoplay()) {
        stopAutoplay();
        return;
      }

      if (!lastTimestamp) {
        lastTimestamp = timestamp;
      }

      const elapsed = timestamp - lastTimestamp;
      lastTimestamp = timestamp;
      setTranslate(translate + (baseSpeed() * elapsed / 1000));
      syncControls();
      frame = window.requestAnimationFrame(autoplayStep);
    };

    const startAutoplay = () => {
      if (!canAutoplay()) return;

      if (window.innerWidth < 990) {
        if (mobileInterval) return;
        mobileInterval = window.setInterval(() => {
          const nextIndex = (nearestIndex() + 1) % originalSlides.length;
          translate = offsetForIndex(nextIndex);
          setTranslate(translate);
          syncControls();
        }, 2000);
        return;
      }

      if (frame) return;
      frame = window.requestAnimationFrame(autoplayStep);
    };

    const handleTouchStart = (event) => {
      if (window.innerWidth >= 990 || !canAutoplay()) return;

      const touch = event.touches?.[0];
      if (!touch) return;

      isTouchDragging = true;
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchStartTranslate = translate;
      stopAutoplay();
    };

    const handleTouchMove = (event) => {
      if (!isTouchDragging) return;

      const touch = event.touches?.[0];
      if (!touch) return;

      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;

      if (Math.abs(deltaY) > Math.abs(deltaX)) return;

      event.preventDefault();
      setTranslate(touchStartTranslate - deltaX);
      syncControls();
    };

    const handleTouchEnd = () => {
      if (!isTouchDragging) return;

      isTouchDragging = false;
      lastTimestamp = 0;
      startAutoplay();
    };

    slider?.addEventListener('input', () => {
      translate = offsetForIndex(Math.max(0, Math.min(maxIndex(), Number(slider.value || 0))));
      setTranslate(translate);
      syncControls();
      lastTimestamp = 0;
    });

    viewport.addEventListener('touchstart', handleTouchStart, { passive: true });
    viewport.addEventListener('touchmove', handleTouchMove, { passive: false });
    viewport.addEventListener('touchend', handleTouchEnd);
    viewport.addEventListener('touchcancel', handleTouchEnd);

    window.addEventListener('resize', () => {
      translate = normalizedTranslate(translate);
      setTranslate(translate);
      syncControls();
      lastTimestamp = 0;
      startAutoplay();
    });

    setTranslate(0);
    syncControls();
    startAutoplay();
  });
});
